<script>
import axios from "axios";
import { db } from "../main";
import "firebase/firestore";
import firebase from "firebase/compat/app";
export default {
  name: "App",
  data: () => ({
    savedLocations: [],
    formData: {
      street: "",
      city: "",
      state: "",
      zip: ""
    }
  }),
  async beforeMount() {
    const snap = await db.collection("locations").get();

    snap.docs.forEach(doc => {
      this.savedLocations.push(doc.data());
    });
  },
  methods: {
    async handleFormSubmit() {
      //validate form
      if (
        !this.formData.street ||
        !this.formData.city ||
        !this.formData.state ||
        !this.formData.zip
      ) {
        alert("You must add a full address!");
        return;
      }

      //Make request
      let address = `${this.formData.street}, ${this.formData.city}, ${this.formData.state} ${this.formData.zip}`;
      let { data } = await axios.post(
        "https://us-central1-geocoding-project-3f025.cloudfunctions.net/geocodeAddressAndSave",
        {
          address: address
        }
      );

      if (data === "No Results") {
        alert("No results for address");
        return;
      }

      //massage data to fit our schema
      let obj = {
        address: data.address,
        geoPoint: {
          latitude: data.geoPoint._latitude,
          longitude: data.geoPoint._longitude
        }
      };

      //add to saved locations to update map
      this.savedLocations.push(obj);

      //clear form
      this.formData.street = "";
      this.formData.city = "";
      this.formData.state = "";
      this.formData.zip = "";
    }
  }
};
</script>

<template>
  <div id="app" class="container mt-5">
    <form @submit.prevent="handleFormSubmit">
      <v-row>
        <v-col md="6">
          <v-text-field label="Street" v-model="formData.street"></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="3">
          <v-text-field label="City" v-model="formData.city"></v-text-field>
        </v-col>
        <v-col md="3">
          <v-text-field label="State" v-model="formData.state"></v-text-field>
        </v-col>
        <v-col md="3">
          <v-text-field label="Zip" v-model="formData.zip"></v-text-field>
        </v-col>
      </v-row>
      <v-btn type="submit" variant="primary">Submit</v-btn>
    </form>

    <GmapMap
      :center="{ lat: 39, lng: -95 }"
      :zoom="4"
      map-type-id="roadmap"
      style="width: 100%; height: 500px; margin-top:60px;"
    >
      <div v-if="savedLocations.length > 0">
        <GmapMarker
          :key="index"
          v-for="(l, index) in savedLocations"
          :position="{ lat: l.geoPoint.latitude, lng: l.geoPoint.longitude }"
        />
      </div>
    </GmapMap>
  </div>
</template>
